import { FiltersCifCups } from "../../../core/models/filtersCifCups/filtersCifCups.model";

const initialFiltersCifCups: FiltersCifCups = {
  cups: [],
  cif: [],
  socialReason: [],
};

export { initialFiltersCifCups };
